module.exports = __webpack_public_path__ + "static/CSAT_Badge-929f2fd3216accb0687dbed083019a94.svg";